import ApiService from "./api_service";
export default {
    async get() {
        return await ApiService.call('get', 'cabin-notes/');
    },
    async post(payload) {
        return await ApiService.call('post', 'cabin-notes/', payload);
    },

    async get_cabin_prices(page, params) {
        return await ApiService.call('get', 'cabin-prices/?page=' + page + '&' + params);
    },
    async get_cabin_prices_full(params) {
        return await ApiService.call('get', 'cabin-prices-full/?' + params);
    },
    async get_cabin_prices_detail(cabin_price_id) {
        return await ApiService.call('get', 'cabin-prices/' + cabin_price_id + '/');
    },
    async post_cabin_price(payload) {
        return await ApiService.call('post', 'cabin-prices/', payload);
    },
    async patch_cabin_price(cabin_price_id, payload) {
        return await ApiService.call('patch', 'cabin-prices/' + cabin_price_id + '/', payload);
    },
    async delete_cabin_price(cabin_price_id) {
        return await ApiService.call('delete', 'cabin-prices/' + cabin_price_id + '/');
    },
    async get_available_cabins(params) {
        return await ApiService.call('get', 'available-cabins/?' + params);
    },
}